(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  const STORAGE_KEY = 'recentlyViewed';

  function getList() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch {
      return [];
    }
  }

  function saveCurrent(handle, maxStore) {
    if (!handle) return;
    let list = getList().filter(Boolean);
    list = [handle, ...list.filter(h => h !== handle)];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, maxStore)));
  }

  function load(sectionEl) {
    if (!sectionEl) return;

    const currentHandle = sectionEl.dataset.currentHandle || '';
    const limit = parseInt(sectionEl.dataset.limit || '4', 10);
    const maxStore = parseInt(sectionEl.dataset.maxStore || '8', 10);
    const view = sectionEl.dataset.view || 'rv-card';

    // Speichern (nur auf Produktseiten relevant)
    saveCurrent(currentHandle, maxStore);

    // Anzeigen: ohne aktuelles Produkt
    const handles = getList()
      .filter(h => h && h !== currentHandle)
      .slice(0, limit);

    const grid = sectionEl.querySelector('[data-rv-grid]');
    if (!grid || handles.length === 0) {
      // leer lassen – Heading bleibt sichtbar
      return;
    }

    // Alles parallel laden, dann einfügen
    Promise.all(
      handles.map(h =>
        fetch('/products/' + encodeURIComponent(h) + '?view=' + encodeURIComponent(view), {
          credentials: 'same-origin'
        })
          .then(r => (r.ok ? r.text() : ''))
          .catch(() => '')
      )
    ).then(parts => {
      const html = parts.filter(Boolean).join('');
      if (!html) return;
      grid.insertAdjacentHTML('beforeend', html);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.recently-viewed-products').forEach(load);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const sectionEl = document.querySelector(
      '.recently-viewed-products[data-section-id="' + event.detail.sectionId + '"]'
    );
    load(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
